// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabsContent_container__1VCgJ {
  padding: 0 15px 15px;
}

.TabsContent_dimensionsContainer__Y0ANS {
  direction: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.TabsContent_mainTitle__OEBPF {
  font-size: 45px;
  color: #333;
}

.TabsContent_title__DZxFj {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.TabsContent_highlight__rCZ9Z {
  color: red;
}

.TabsContent_text__q1wvY {
  font-size: 16px;
  margin: 10px 0;
  color: #555;
}

.TabsContent_sentence__MCvQT {
  font-size: 16px;
  color: #555;
}

.TabsContent_warningBox__vx6Yz {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #ccc;
  background-color: #fff;
  border-left: 5px solid red;
  display: flex;
  align-items: center;
  gap: 10px;
}

.TabsContent_warningBox__vx6Yz i {
  color: #ff6b6b;
}

.TabsContent_warningIcon__LUWmg {
  color: red;
  font-weight: bold;
  font-size: 20px;
  margin-right: 10px;
}

.TabsContent_pdfIcon__6Uqic {
  font-size: 2rem; /* Ajustează dimensiunea iconului */
  color: red; /* Culoarea iconului */
  margin-right: 8px; /* Spațiu între icon și text */
}

.TabsContent_pdfLink__cELsb {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit; /* Opțional, pentru a folosi culoarea textului curent */
}

.TabsContent_guaranteeBox__ZEIQJ {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.TabsContent_guaranteeContent__6CEA- {
  display: flex;
  align-items: center;
  gap: 10px;
}

.TabsContent_guaranteeContent__6CEA- i {
  color: #ff6b6b;
  font-size: 24px;
}

.TabsContent_guaranteeContent__6CEA- p {
  margin: 0;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.TabsContent_productName__YYfsA {
  color: #ff0000;
  font-weight: bold;
}

.TabsContent_imageContainer__5dZSY {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  height: auto; /* Asigură-te că imaginea are spațiu pentru a fi centrată */
}

.TabsContent_centeredImage__q2HNU {
  max-width: 80%; /* Ajustează dimensiunea imaginii pentru a preveni depășirile */
  height: auto;
}

.TabsContent_table__-IU6I {
  width: 100%;
}
.TabsContent_table__-IU6I thead {
  background-color: #2c3e50;
  color: #fff;
}

.TabsContent_table__-IU6I th,
.TabsContent_table__-IU6I td {
  padding: 10px;
  text-align: center;
}

.TabsContent_table__-IU6I tbody tr {
  border-bottom: 1px solid #ddd;
}

.TabsContent_table__-IU6I tbody tr:hover {
  background-color: #f1f1f1;
}

.TabsContent_table__-IU6I td:first-child,
.TabsContent_table__-IU6I th:first-child {
  text-align: left;
}

/* Responsive */
@media (max-width: 768px) {
  .TabsContent_container__1VCgJ {
    margin: 0;
    padding: 0;
  }

  .TabsContent_dimensionsContainer__Y0ANS {
    margin: 0;
    padding: 0;
  }

  .TabsContent_mainTitle__OEBPF {
    font-size: 30px;
    text-align: center;
  }

  .TabsContent_title__DZxFj {
    text-align: left;
  }

  .TabsContent_tableContainer__92L3p {
    overflow-x: auto; /* Permite scroll pe orizontală */
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box; /* Asigură includerea padding-ului în dimensiuni */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Product/ProductDetails/TabsContent/TabsContent.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe,EAAE,mCAAmC;EACpD,UAAU,EAAE,sBAAsB;EAClC,iBAAiB,EAAE,8BAA8B;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc,EAAE,uDAAuD;AACzE;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY,EAAE,2DAA2D;AAC3E;;AAEA;EACE,cAAc,EAAE,+DAA+D;EAC/E,YAAY;AACd;;AAEA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB,EAAE,iCAAiC;IACnD,iCAAiC;IACjC,sBAAsB,EAAE,kDAAkD;EAC5E;AACF","sourcesContent":[".container {\n  padding: 0 15px 15px;\n}\n\n.dimensionsContainer {\n  direction: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.mainTitle {\n  font-size: 45px;\n  color: #333;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n}\n\n.highlight {\n  color: red;\n}\n\n.text {\n  font-size: 16px;\n  margin: 10px 0;\n  color: #555;\n}\n\n.sentence {\n  font-size: 16px;\n  color: #555;\n}\n\n.warningBox {\n  margin-top: 20px;\n  padding: 15px;\n  border: 1px solid #ccc;\n  background-color: #fff;\n  border-left: 5px solid red;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.warningBox i {\n  color: #ff6b6b;\n}\n\n.warningIcon {\n  color: red;\n  font-weight: bold;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.pdfIcon {\n  font-size: 2rem; /* Ajustează dimensiunea iconului */\n  color: red; /* Culoarea iconului */\n  margin-right: 8px; /* Spațiu între icon și text */\n}\n\n.pdfLink {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  color: inherit; /* Opțional, pentru a folosi culoarea textului curent */\n}\n\n.guaranteeBox {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.guaranteeContent {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.guaranteeContent i {\n  color: #ff6b6b;\n  font-size: 24px;\n}\n\n.guaranteeContent p {\n  margin: 0;\n  font-size: 14px;\n  color: #333;\n  line-height: 1.5;\n}\n\n.productName {\n  color: #ff0000;\n  font-weight: bold;\n}\n\n.imageContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n  height: auto; /* Asigură-te că imaginea are spațiu pentru a fi centrată */\n}\n\n.centeredImage {\n  max-width: 80%; /* Ajustează dimensiunea imaginii pentru a preveni depășirile */\n  height: auto;\n}\n\n.table {\n  width: 100%;\n}\n.table thead {\n  background-color: #2c3e50;\n  color: #fff;\n}\n\n.table th,\n.table td {\n  padding: 10px;\n  text-align: center;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid #ddd;\n}\n\n.table tbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n.table td:first-child,\n.table th:first-child {\n  text-align: left;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .container {\n    margin: 0;\n    padding: 0;\n  }\n\n  .dimensionsContainer {\n    margin: 0;\n    padding: 0;\n  }\n\n  .mainTitle {\n    font-size: 30px;\n    text-align: center;\n  }\n\n  .title {\n    text-align: left;\n  }\n\n  .tableContainer {\n    overflow-x: auto; /* Permite scroll pe orizontală */\n    -webkit-overflow-scrolling: touch;\n    box-sizing: border-box; /* Asigură includerea padding-ului în dimensiuni */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TabsContent_container__1VCgJ`,
	"dimensionsContainer": `TabsContent_dimensionsContainer__Y0ANS`,
	"mainTitle": `TabsContent_mainTitle__OEBPF`,
	"title": `TabsContent_title__DZxFj`,
	"highlight": `TabsContent_highlight__rCZ9Z`,
	"text": `TabsContent_text__q1wvY`,
	"sentence": `TabsContent_sentence__MCvQT`,
	"warningBox": `TabsContent_warningBox__vx6Yz`,
	"warningIcon": `TabsContent_warningIcon__LUWmg`,
	"pdfIcon": `TabsContent_pdfIcon__6Uqic`,
	"pdfLink": `TabsContent_pdfLink__cELsb`,
	"guaranteeBox": `TabsContent_guaranteeBox__ZEIQJ`,
	"guaranteeContent": `TabsContent_guaranteeContent__6CEA-`,
	"productName": `TabsContent_productName__YYfsA`,
	"imageContainer": `TabsContent_imageContainer__5dZSY`,
	"centeredImage": `TabsContent_centeredImage__q2HNU`,
	"table": `TabsContent_table__-IU6I`,
	"tableContainer": `TabsContent_tableContainer__92L3p`
};
export default ___CSS_LOADER_EXPORT___;
